import React, { useEffect, useRef, useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Autocomplete,
  Backdrop,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import {
  getProcessesStatusList,
  getProcessesStatusListByNOA,
} from "../../store/process/actions";

import ConfirmModal from "../CGITrackingNew/ConfirmModal";
import { getUserRole, ShowError } from "../../_helper/helper";
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { filterBy } from "@progress/kendo-react-data-tools";
import axios from "axios";
import { useAuth } from "oidc-react";
import { formatNumber } from "@telerik/kendo-intl";
import { Icon } from "@progress/kendo-react-common";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";

const DeptAdmin = "Dept Admin";
const Submitted = "Submitted";
const CertOfficer = "Cert Officer";
const AgencyDirector = "Agency Director";
const BBMR = "BBMR";
const AssignAnalyst = "Assign Analyst";
const AnalystReview = "Analyst Review";
const SupervisorReview = "Supervisor Review";
const AdminStaffReview = "Admin Staff Review";
const DirectorReview = "Director Review";
const AdminStaffRouting = "Admin Staff Routing";
const Classification = "Classification";
const Recruitment = "Recruitment";
const EMR = "EMR";
const DrugTesting = "Drug Testing";
const Records = "Records";

const columnsArray = [
  {
    field: "ParentID",
    header: "Parent Id",
    width: "130px",
  },
  {
    field: "Job_Order",
    header: "Job Order Number",
    width: "200px",
  },
  {
    field: "Main_Account",
    header: "Main Account",
    width: "300px",
  },
  {
    field: "No_of_Applicants",
    header: "Total Applicants",
    width: "150px",
  },
  {
    field: "Cost",
    header: "Total Cost",
    width: "150px",
  },
];

const BBMRSummaryModal = ({ open, onClose, ParentId, batchName, rate, hours, hrControlNo = '', noa = '' }) => {
  const { searchResultsV2 } = useSelector(
    (state) => state.advanceSearchv2Reducer
  );
  const { gg1loading } = useSelector(
    (state) => state.GG1Reducer
  );
  const [BBMRList, setBBMRList] = useState([]);

  const { BBMRList: BBMRAnalyst, isBBMRLoading } = useSelector(
    (state) => state.ggTrackSlice
  );
  // useEffect(() => {
  //   dispatch(getBBMRAnalyst());
  // }, []);

  // useEffect(() => {
  //   if (BBMRAnalyst.length) {
  //     setBBMRList(
  //       BBMRAnalyst
  //       // .map((item) => {
  //       //   return {item
  //       //     // label: item.EmployeeName_LFM,
  //       //     // value: item.EmployeeID,
  //       //   };
  //       // })
  //     );
  //   }
  // }, [BBMRAnalyst]);

  // const { results =[] } =
  //   searchResultsV2["bbmr_analyst_lookup"] || {results:[]}

  const [selectedItem, setSelectedItem] = useState(null);
  const [res, setRes] = useState([]);
  const dispatch = useDispatch();
  const { userData } = useAuth();
  const role = getUserRole(userData);
  // const batchId = 2;



  useEffect(() => {
    // Call advanceSearch action with payload
    // const payload = {
    //   id: "Blanket_GG1_Summary_for_BBMR",
    //   gridId: "Blanket_GG1_Summary_for_BBMR",
    //   location: "global",
    //   columnLocation: "global",
    //   tableName: "vw_Blanket_GG1_Summary_for_BBMR",
    //   searchParams: "[]",
    //   columns: "*",
    //   columnRefernces: "",
    //   pageNumber: 1,
    //   pageSize: 1000,
    //   sortData: "",
    //   // additionalWhere: additionalWhere,
    //   additionalWhere: "",
    // };
    // dispatch(
    //   advanceSearch({ bbmr_analyst_lookup: payload }, "bbmr_analyst_lookup")
    // );

  }, []);

  const getBatchInfo = (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "vw_Blanket_GG1_Summary_for_BBMR",
      SearchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      // orderBy: "Id ASC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `ParentID=${Id}`,
    };
    axios
      .post(`${newBaseURL}/AdvanceSearch/global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalResponse = response.data.results;
        console.log("finalResponsexxx", finalResponse, response)
        setBBMRList(finalResponse);

      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };
  useEffect(() => {
    if (ParentId) {
      getBatchInfo(ParentId)
    }
  }, [ParentId])

  // using to show loader on base of flag
  // useEffect(() => {
  //   console.log("gg1loading", gg1loading);
  // }, [gg1loading]);

  // useEffect(() => {
  //   console.log("results 1123465", results)
  //   if (results && results?.length) {
  //     setRes(results)
  //   }
  // }, [results]);

  // const handleAssign = () => {
  //   if (selectedItem) {
  //     const payload = {
  //       bbmrAnalyst: selectedItem.EmployeeID,
  //       hrControl: HrControl,
  //     };
  //     dispatch(updateGg1Analyst(payload));
  //     setTimeout(() => {
  //       window.location.href=""
  //     }, 1500);

  //   } else {
  //     console.error("No item selected");
  //   }
  // };

  // const payload ={
  //   bbmrAnalyst:"1234",
  //   hrControl:"1234567"
  // }
  //   const handleAssign = () => {
  //     dispatch(updateGg1Analyst(payload))

  //   };
  const [filter, setFilter] = React.useState();
  // const handleFilterChange = (event) => {
  //   if (event) {
  //     setFilter(event.filter);
  //   }
  // };
  const handleFilterChange = (event) => {
    if (event) {
      const value = event.filter.value.toLowerCase();
      setFilter({
        logic: "or",
        filters: columnsArray.map((column) => ({
          field: columnsArray.field,
          operator: "contains",
          value,
        })),
      });
    }
  };


  const giveTotal = (data) => {
    const costSum = data.reduce((sum, item) => sum + (item.Cost ?? 0), 0);
    return costSum
  }
  const data = [
    {
      "ParentID": 1,
      "Job_Order": 23131312,
      "Main_Account": 232132131 - 32131,
      "No_of_Applicants": 100,
      "Cost": 1600
    },
  ]
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => { },
    documentTitle: `eHRP-BudgetSummary-${moment().format("MM-DD-YY-HH:mm:ss")}`,
  });


  const getFormattedAmount = (amount) => {
    var p = parseFloat(amount).toFixed(2);
    p = formatNumber(p, "n2");
    return p;
  }

  return (
    <div>
      <Dialog onClose={onClose} maxWidth="md" open={open}>
        {/* <MultiColumnComboBox
          
          data={BBMRList}
          // data={filter ? filterBy(results, filter) : results}
          // data={filter ? filterBy(BBMRList, filter) : BBMRList}
          filterable={true}
          onFilterChange={handleFilterChange}
          columns={columns}
          textField={"ParentID"}
          style={{
            width: "300px",
          }}
          className="mt-3 mb-3"
          placeholder="Please select ..."
          onChange={(e) => setSelectedItem(e.target.value)}
        /> */}
        <div ref={componentRef}>
          <DialogTitle style={{ display: 'flex', justifyContent: 'space-between' }} >
            Budget Summary {batchName != "" ? `- ${batchName} (${hrControlNo})` : ""}
          </DialogTitle>
          <DialogContent dividers={"paper"} ref={componentRef}>
            {noa?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" && (
              <div style={{ display: "flex", gap: 10 }}>
                {rate ?
                  <Typography >
                    <b>Rate:</b> ${rate}
                  </Typography>
                  : <Typography >
                    <b>Rate:</b> Unassigned
                  </Typography>
                }
                {hours > 0 ?
                  <Typography >
                    <b>Not to exceed number of hours:</b> {hours} Hrs
                  </Typography>
                  : <Typography >
                    <b>Not to exceed number of hours:</b> Unassigned
                  </Typography>
                }
              </div>
            )}
            <TableContainer >
              {hours > 0 ?
                <Table
                  sx={{ minWidth: 700 }}
                  aria-label="simple table"
                >
                  {BBMRList &&
                    BBMRList?.length ? (
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr No</TableCell>
                        {columnsArray?.filter((col) => col.field != "ParentID")
                          ?.map((col) => (
                            <TableCell key={col.field} style={{ textAlign: col.field == "Cost" ? "center" : "left" }}>
                              {col.field.replace(/_/g, ' ')}
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                  ) : null}
                  <TableBody>
                    {BBMRList &&
                      BBMRList?.length ? (
                      BBMRList.map((item, i) => {
                        return (

                          <TableRow style={{ backgroundColor: i % 2 ? "" : "aliceblue" }}>
                            <TableCell>{i + 1}</TableCell>
                            {columnsArray?.filter((col) => col.field !== "ParentID")
                              .map((col) => (
                                <TableCell key={col.field}>
                                  {/* {col.field == "Cost" ?
                              // item[col.field] ? `$ ${item[col.field]}` : "" 
                              item[col.field] ? `$ ${getFormattedAmount(item[col.field])}` : "$ 0.00" 
                              : item[col.field]} */}
                                  {col.field === "Cost" ? (
                                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                      <span style={{ marginRight: "2px" }}>$</span>
                                      <span style={{ textAlign: "right", minWidth: "60px" }}>
                                        {item[col.field] ? getFormattedAmount(item[col.field]) : "0.00"}
                                      </span>
                                    </div>
                                  ) : (
                                    item[col.field]
                                  )}
                                </TableCell>
                              ))}

                          </TableRow>



                        );
                      })

                    ) : (
                      <div className="text-center p-2">
                        No Data Found
                      </div>
                    )}

                    <TableRow style={{ backgroundColor: "aliceblue" }}>
                      <TableCell colSpan={3}></TableCell>
                      <TableCell colSpan={1}><b>Total</b></TableCell>

                      <TableCell>
                        {/* $ {getFormattedAmount(giveTotal(BBMRList))}  */}
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                          <span style={{ marginRight: "2px" }}>$</span>
                          <span style={{ textAlign: "right", minWidth: "60px" }}>
                            {/* {item[col.field] ? getFormattedAmount(item[col.field]) : "0.00"} */}
                            {getFormattedAmount(giveTotal(BBMRList))}
                          </span>
                        </div>
                      </TableCell>


                    </TableRow>
                  </TableBody>
                </Table>
                : <div>Budget Summary is not Available, Please Update Rate & Not to exceed number of hours</div>
              }
            </TableContainer>
          </DialogContent>
        </div>
        <DialogActions>

          <Button onClick={onClose} color="primary">
            Close
          </Button>
          <Btn
            attrBtn={{
              className: "m-1",
              color: "primary",
              onClick: () => handlePrint(),
              disabled: rate ? false : true
            }}
          >
            <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="print" />
            Print
          </Btn>
        </DialogActions>

      </Dialog>
    </div>
  );
};
export default BBMRSummaryModal;
